import { render, staticRenderFns } from "./PrintOdds.vue?vue&type=template&id=6d458c2e&scoped=true"
import script from "./PrintOdds.vue?vue&type=script&lang=ts"
export * from "./PrintOdds.vue?vue&type=script&lang=ts"
import style0 from "./PrintOdds.vue?vue&type=style&index=0&id=6d458c2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d458c2e",
  null
  
)

export default component.exports